import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-website-related-content',
  templateUrl: './website-related-content.component.html',
})
export class WebsiteRelatedContentComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()

  constructor() {
  }

  ngOnInit() {
  }

}
